<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="viewStatus == 1">
      <sticky-top>
        <div class="header">
          <div class="title">我的项目</div>          
          <div class="header-right">
            <el-select v-model="f_publish" placeholder="发布过滤" @change='onPublishChange'>
              <el-option
                v-for="item in fileter_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <lin-search @query="onQueryChange" ref="searchKeyword" />
            <el-button type="primary" icon="el-icon-circle-plus-outline" round @click="handleAdd">新建项目</el-button>
          </div>
        </div>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @handleOperate="handleOperate"
        @row-click="rowClick"
        v-loading="loading"></lin-table>
    </div>      

    <!-- 添加页面 -->
    <project-add v-else-if="viewStatus == 2" @editClose="editClose" :dataID="dataID"></project-add>
    
    <!-- 编辑页面 -->
    <project-editor v-else-if="viewStatus == 3" @editClose="editClose" :dataID="dataID"></project-editor>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import LinTable from '@/components/base/table/lin-table'
import ProjectAdd from './project/ProjectAdd'
import ProjectEditor from './project/ProjectEditor'
import projectApi from '../models/project'
import TableImage from '../../Common/components/TableImage'
import LinSearch from '@/components/base/search/lin-search'
import ChangePublish from './project/ChangePublish'

export default {
  components: {
    LinTable,
    LinSearch,
    ProjectAdd,
    ProjectEditor,
  },
  data() {
    return {
      tableColumn: [        
        {
          prop: 'logo',
          label: '图标',
          style: {width:"80px",height:"80px"},
          component: TableImage,
        },
        { prop: 'title', label: '名称' },
        { prop: 'id', label: '编号' },
        { prop: 'summary', label: '简介' },
        { prop: 'published', label: '是否发布', component: ChangePublish},
      ],
      tableData: [],
      operate: [],
      viewStatus: 1,
      dataID: 1,
      searchKeyword:'',

      selectedRow: {},
      f_publish: null,
      fileter_options: [{
        label:'所有',
        value: 0,
      },{
        label:'未发布',
        value: 1,
      },{
        label:'已发布',
        value: 2,
      },] 
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = [
      {
        name: '进入项目',
        type: 'primary',
        operate: "enter",
      },
      {
        name: '浏览',
        type: 'primary',
        operate: "view",
      },
      {
        name: '编辑',
        func: 'handleEdit',
        type: 'primary',
      },
      {
        name: '删除',
        func: 'handleDelete',
        type: 'danger',
        auth: '删除合作商',
      }]
    this.loading = false
  },
  methods: {
    ...mapActions(['setProject']),
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await projectApi.gets({ count: this.pageCount, page: this.currentPage, q: this.searchKeyword, f_publish:this.f_publish })
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    //info: { index, row, operate }
    handleOperate(info) {
      if(info.operate == 'enter') {
        this.setProject(info.row.id)
        this.$router.push('/d_project/info');
      }else if(info.operate == 'view') {
        window.open(info.row.url);
      }
    },
    async onPublishChange() {
      await this.getDatas()
    },
    handleAdd() {
      this.viewStatus = 2
    },
    handleEdit(val) {
      this.viewStatus = 3
      this.dataID = val.row.id
    },
    handleDelete(val) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await projectApi.delete(val.row.id)
        if (res.error_code === 0) {
          await this.getDatas()
          this.$message({
            type: 'success',
            message: `${res.msg}`,
          })
        }
      })
    },
    rowClick() {

    },
    editClose() {
      this.viewStatus = 1
      this.getDatas()
    },

    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}
</style>
